{
  "slug": "low-iq-scores-explained",
  "title": "低智商分数的解释负责任",
  "description": "了解较低的智商分数范围、置信区间、适应性功能,以及为什么单独的分数从来不会定义一个人或确立诊断。",
  "summary": "较低的智商值描述了相对于规范组的选定任务的表现,需要在不确定性、获取需求、发展和日常功能的基础上进行谨慎、尊重的解释。",
  "category": "智商分数解释",
  "sections": [
    {
      "heading": "低分可以和不能意味着什么",
      "paragraphs": [
        "平时...100, SD- 无法确定15 分数低于 85 低于总体平均值且得分接近 的 70 准确的百分比和分类取决于仪器和规范,但一般来说,这些都可以用于测量血压。",
        "结果并不衡量人的价值,善良,创造力,实际经验,或每一种能力,语言,教育,感官或运动的接触,健康,注意力,和测试条件可能会影响表现。"
      ]
    },
    {
      "heading": "诊断并非仅仅依靠智商",
      "paragraphs": [
        "智力残疾的专业评估考虑智力功能与适应功能在概念、社会和实际生活领域,在发育期开始。 单一的在线或筛选分数不能确定这种诊断。",
        "合格的评估人员选择适当的措施，考虑调整和背景，审查置信区间，并整合来自多个来源的信息。"
      ]
    },
    {
      "heading": "使用结果了解支持需求",
      "paragraphs": [
        "建设性的问题是哪些任务更容易或更难,以及什么样的支持能够提高参与度。 明确的指示、适当的额外时间、辅助技术、教学和环境变化都很重要。",
        "如果低的结果是意外的或可能会影响服务, 讨论它与合格的专业人士,而不是反复采取在线测试或对待一个截止值为完全准确."
      ]
    }
  ],
  "faqs": [
    {
      "question": "智商低于 18.5 70 智力残疾的原因是什么?",
      "answer": "诊断还需要评估适应性功能和发育史,使用适当的专业标准。"
    },
    {
      "question": "测试条件能降低分数吗?",
      "answer": "是的,疲劳、疾病、焦虑、语言不匹配、分心、无法访问的障碍和其他条件都会影响性能。"
    }
  ],
  "related": ["iq-80-meaning", "iq-score-ranges-explained", "how-is-iq-measured"],
  "sources": [
    {
      "label": "智力残疾的症状和表现",
      "url": "https://www.aaidd.org/docs/default-source/intellectualdisability/12th-ed-twenty-questions-faq.pdf"
    },
    {
      "label": "皮尔逊-西非信息系统5 样本得分报告",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
